<template>
  <div>
    <v-row class="mb-4">
      <v-col :cols="removable ? (value ? 10 : 11) : (value ? 11 : 12)">
        <v-file-input
            class="flex-1-0"
            show-size
            :label="value ? value.fileName : label"
            :accept="accept"
            :loading="fileInputLoading"
            outlined
            hide-details
            @change="selectFile($event)"
        ></v-file-input>
      </v-col>
      <v-col v-if="value" cols="1" class="d-flex align-center justify-center">
        <v-btn
            icon
            color="primary"
            :loading="downloadLoading"
            :aria-label="`Download ${value.fileName || label}`"
            :title="`Download ${value.fileName || label}`"
            @click="downloadFile">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-col>
      <v-col v-if="removable" cols="1" class="d-flex align-center justify-center">
        <v-btn
            type="button"
            icon
            color="error"
            :aria-label="removeLabel"
            :title="removeLabel"
            @click="$emit('remove')">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="value && value.contentType && value.contentType.startsWith('image/')" class="mb-4">
      <v-col cols="12">
        <v-img :src="value.url" max-height="220" contain />
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :timeout="6000" :color="snackbarColor" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'DocumentUpload',

  props: {
    value: Object,
    label: {
      type: String,
      default: 'Image'
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    removable: {
      type: Boolean,
      default: false
    },
    removeLabel: {
      type: String,
      default: 'Remove file'
    }
  },

  data() {
    return {
      fileInputLoading: false,
      downloadLoading: false,
      snackbar: false,
      snackbarColor: 'success',
      snackbarText: ''
    }
  },

  methods: {
    downloadFile() {
      this.downloadLoading = true;
      axios.get(this.value.url, { responseType: 'blob' })
        .then(response => {
          const downloadUrl = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = this.value.fileName || 'download';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
        })
        .catch(() => {
          this.snackbar = true;
          this.snackbarText = 'Error downloading file';
          this.snackbarColor = 'error';
        })
        .finally(() => {
          this.downloadLoading = false;
        });
    },

    selectFile(file) {
      if (!file) {
        return;
      }

      let formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", file.name);
      formData.append("contentType", file.type);

      this.fileInputLoading = true;
      axios.post('/document', formData)
        .then(response => {
          this.$emit('input', response.data);
        })
        .catch(() => {
          this.snackbar = true;
          this.snackbarText = 'Error uploading file';
          this.snackbarColor = 'error';
        })
        .finally(() => {
          this.fileInputLoading = false;
        });
    }
  }
}
</script>
